import { useEffect } from "react";

/**
 * SEOHead — sets page-specific <title>, <meta description>, and <link rel="canonical">
 * without any third-party library. Call once per page component.
 */
const SEOHead = ({ title, description, canonical }) => {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Meta description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }

    // Canonical & og:url
    if (canonical) {
      // canonical link
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);

      // og:url
      let ogUrl = document.querySelector('meta[property="og:url"]');
      if (!ogUrl) {
        ogUrl = document.createElement("meta");
        ogUrl.setAttribute("property", "og:url");
        document.head.appendChild(ogUrl);
      }
      ogUrl.setAttribute("content", canonical);
    }
  }, [title, description, canonical]);

  return null;
};

export default SEOHead;
